const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Get premium benefits for over 35 features, including Enhancers, Removers, AI Translators, Screen Recorders, and more. Get it all at one affordable price.',
  Upgrade: 'Upgrade',
  Tools: 'Tools',
  MyProjects: 'My Projects',
  MyAccount: 'My Account',
  Subscription: 'Subscription',
  LogOut: 'Log Out',
  PopularTools: 'Popular Tools',
  Enhance: 'Enhance',
  Remove: 'Remove',
  Animate: 'Animate',
  Extract: 'Extract',
  SaveThreeDays:
    'Projects are stored for 3 days, please download them after processing.',
  All: 'All',
  Video: 'Video',
  Image: 'Image',
  Audio: 'Audio',
  minutesAgo: 'minutes ago',
  hoursAgo: 'hours ago',
  daysAgo: 'days ago',
  Modified: 'Modified',
  Order: 'Order',
  EarliestToLatest: 'Earliest to Latest',
  LatestToEarliest: 'Latest to Earliest',
  NoProject: 'No project yet. Quick start with',
  OnlineTools: 'Online Tools',
  AIVideoEnhancer: 'AI Video Enhancer',
  Enhancer4K: 'One-click to AI enhance videos up to 4K online',
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'AI enhance images losslessly up to 8X online',
  View: 'View',
  Download: 'Download',
  MultipleSelect: 'Multiple-select',
  Delete: 'Delete',
  SubscriptionHistory: 'Subscription History',
  NoValidSubscription: 'No valid subscription.',

  veContent: 'One-click to AI enhance videos up to 4K online',
  peContent: 'AI enhance images losslessly up to 8X online',
  rmvContent: 'Remove watermark from video',
  rmttContent: 'Remove TikTok video watermarks in a blink',
  dynamicContent: 'Animate your photo online',
  rmbgContent: 'Remove background from image',
  youMayNeed: 'You may need',
  new: 'New',
  rather: "I'd rathet pay full price at $4.49/week.",
  discountPrice: '$ 0.99 / 7days Pro',
  exclDeal: 'New Exclusive Deal!',
  endDeal: 'Hurry! Deal ends in',
  loginYourAccount: 'Log in to your HitPaw account',
  signUpYourAccount: 'Sign Up to your HitPaw account',

  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};

export default upgradePersonal;
